module.exports = __webpack_public_path__ + "static/media/mimi6.1ce35a6b.gif";